// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-PhotoContainer-module--cls1--3I4K8","cls2":"styles-PhotoContainer-module--cls2--1bJ0c styles-PhotoContainer-module--cls1--3I4K8"};